export default "__VITE_ASSET__a5590098__"